import React, { useState, useEffect, useRef } from 'react';
import { useElements, useStripe } from '@stripe/react-stripe-js';

const StripeApplePay = ({ clientSecret, userData, totalAmount, redirect, updateIntentHandle }) => {
  const stripe = useStripe();
  const elements = useElements();
  const prButtonRef = useRef(null);
  const effectRunIdRef = useRef(0);

  useEffect(() => {
    if (!stripe || !elements || !clientSecret || totalAmount == null || totalAmount === '') {
      return;
    }

    // Prevent stale async work from previous totals from re-mounting an old button.
    const runId = ++effectRunIdRef.current;
    let cancelled = false;

    const amountNum = Number(totalAmount);
    if (Number.isNaN(amountNum) || amountNum <= 0) {
      console.error("Invalid total amount");
      return;
    }

    // Tear down any existing button immediately so we can't click a stale one.
    if (prButtonRef.current) {
      try {
        prButtonRef.current.destroy();
      } catch (_) {}
      prButtonRef.current = null;
    }
    const mountEl = document.getElementById('payment-request-button');
    if (mountEl) {
      mountEl.innerHTML = '';
    }

    // Stripe Payment Request (Apple/Google/Link Pay) expects amount in smallest currency unit (cents for EUR).
    // totalAmount from parent is in euros (donation + tips + goodies), so convert to cents.
    const amountInCents = Math.round(amountNum * 100);

    const newPaymentRequest = stripe.paymentRequest({
      country: 'DE',
      currency: 'eur',
      total: { label: 'Total', amount: amountInCents },
      requestPayerName: true,
      requestPayerEmail: true,
    });

    updateIntentHandle && updateIntentHandle(false);

    newPaymentRequest.canMakePayment().then((result) => {
      if (cancelled || effectRunIdRef.current !== runId) return;
      if (result) {

        if (prButtonRef.current) {
          prButtonRef.current.destroy();
        }

        const prButton = elements.create('paymentRequestButton', {
          paymentRequest: newPaymentRequest,
          style: { paymentRequestButton: { type: 'buy' } },
        });

        // Guard in case the component was updated/unmounted mid-flight.
        if (!cancelled && effectRunIdRef.current === runId) {
          prButton.mount('#payment-request-button');
        }
        prButtonRef.current = prButton;

        newPaymentRequest.on('paymentmethod', async (ev) => {
          const { paymentIntent, error: confirmError } =
            await stripe.confirmCardPayment(
              clientSecret,
              { payment_method: ev.paymentMethod.id },
              { handleActions: false }
            );

          if (confirmError) {
            ev.complete('fail');
          } else {
            ev.complete('success');
            if (paymentIntent.status === 'requires_action') {
              const { error } = await stripe.confirmCardPayment(clientSecret);
              if (error) {
                console.log('Error: ', error);
              } else {
                localStorage.removeItem('goodies');
                redirect();
              }
            } else {
              localStorage.removeItem('goodies');
              redirect();
            }
          }
        });
      } else {
        if (document.getElementById('payment-request-button')) {
          document.getElementById('payment-request-button').style.display = 'none';
        }
      }
    });

    return () => {
      cancelled = true;
      if (prButtonRef.current) {
        prButtonRef.current.destroy();
        prButtonRef.current = null;
      }
    };
  }, [stripe, elements, totalAmount, clientSecret, updateIntentHandle, userData]);

  return (
    <div>
      <div id="payment-request-button"></div>
    </div>
  );
};

export default StripeApplePay;